export default __webpack_public_path__ + "static/media/cancel.ab42e3fc.svg";